import { alpha, ButtonProps } from '@mui/material'

import { FCWithChildren } from '@/types'

import Button from '@/Components/Common/Button/Button'

const PageHeaderButton: FCWithChildren<ButtonProps> = ({
  children,
  sx,
  ...props
}) => (
  <Button
    variant="contained"
    color="secondary"
    sx={{
      ...sx,
      '&.Mui-disabled': {
        color: alpha('#FFF', 0.45)
      }
    }}
    {...props}
  >
    {children}
  </Button>
)

export default PageHeaderButton
